import { useEffect } from 'react';

export function useDocumentTitle(title: string | undefined, description?: string) {
  useEffect(() => {
    if (title) document.title = `${title} — PowerQuant`;
    if (description) {
      let tag = document.querySelector<HTMLMetaElement>('meta[name="description"]');
      if (!tag) {
        tag = document.createElement('meta');
        tag.name = 'description';
        document.head.appendChild(tag);
      }
      tag.content = description;
    }
  }, [title, description]);
}
